import * as React from "react";

const IconTW = (props) => (
  <svg width={40} height={40} viewBox="0 0 40 40" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20z"
      className="bg-circle"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.401 16.256l.042.692-.7-.085c-2.546-.325-4.77-1.426-6.659-3.276l-.923-.918-.238.678c-.503 1.51-.182 3.107.868 4.18.56.593.433.678-.532.325-.336-.113-.63-.198-.657-.155-.098.098.237 1.384.503 1.892.364.706 1.105 1.398 1.917 1.808l.685.325-.811.014c-.784 0-.812.014-.728.31.28.919 1.385 1.893 2.616 2.317l.868.296-.756.452a7.876 7.876 0 01-3.749 1.045c-.63.015-1.147.071-1.147.113 0 .142 1.707.933 2.7 1.243 2.98.918 6.52.523 9.177-1.045 1.889-1.116 3.777-3.333 4.659-5.48.475-1.144.95-3.234.95-4.237 0-.65.043-.734.826-1.511.462-.452.896-.946.98-1.088.14-.268.125-.268-.588-.028-1.19.424-1.357.368-.77-.268.434-.452.952-1.271.952-1.511 0-.043-.21.028-.448.155-.252.141-.811.353-1.23.48l-.756.24-.686-.466c-.377-.254-.91-.536-1.189-.621-.713-.198-1.805-.17-2.448.056-1.749.636-2.854 2.274-2.728 4.068z"
      fill="#fff"
    />
  </svg>
)

export default IconTW;